export * from './keyvalue.pipe';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/keyvalue/index.ts